import DigestTiming from "./DigestTiming";

export default DigestTiming;
